import React from 'react'
import {
  Table
} from 'reactstrap'
import styled from 'styled-components'
import { confirmAlert } from 'react-confirm-alert'
import sortBy from 'lodash.sortby'
import moment from 'moment';

import { FaTrash } from 'react-icons/fa'

import 'react-confirm-alert/src/react-confirm-alert.css'

const TrashButton = styled(FaTrash)`
  cursor: pointer;
`

const LinkCell = styled.span`
  display: block;
  max-width: 620px;
  word-break: break-all;
`

const ItemTableNews = ({ item, remove }) => {
  const date = moment.utc(item.date).format('DD/MM/YYYY');

  const confirm = () => {
    confirmAlert({
      title: 'Confirmar exclusão',
      message: 'Tem certeza que quer excluir essa publicação?',
      buttons: [
        {
          label: 'Sim',
          onClick: () => remove(item.id)
        },
        {
          label: 'Não',
          onClick: () => {}
        }
      ]
    })
  }

  return (
    <tr>
      <td>{item.title}</td>
      <td><LinkCell>{item.link}</LinkCell></td>
      <td>{date}</td>
      <td>
        <TrashButton onClick={confirm} />
      </td>
    </tr>
  )
}

const TableNews = ({ remove, news }) => {
  const { list, loading } = news

  if (loading) return null

  return (
    <Table>
      <thead>
        <tr>
          <th>Título</th>
          <th>Link</th>
          <th>Data</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {sortBy(list, 'date').reverse().map(item =>
          <ItemTableNews
            remove={remove}
            item={item}
            key={item.id} />
        )}
      </tbody>
    </Table>
  )
}

export default TableNews



// WEBPACK FOOTER //
// ./src/components/molecules/TableNews/TableNews.js